<template>
  <div>
    <HeadingExtraSmall weight="normal">
      {{ control.label }}
      <IconTooltip :tooltipContainerClass="$style.tooltip">
        <p>
          {{ control.tooltip.variables.message }}
        </p>
      </IconTooltip>
    </HeadingExtraSmall>
    <CopyWell
      :class="$style.copyWellFull"
      :isEditable="true"
      :multiLine="true"
      :showValidationMessage="true"
      :value="value"
      @input="handleChange"
    />
    <Grid>
      <GridItem :gridSpan="4">
        <StatusBadge
          v-if="isValid && isValidateClicked"
          :class="$style.buttonGroupSpacing"
          icon="checkmark"
          iconPosition="left"
          status="success"
          :text="validJsonMsg"
        />
        <StatusBadge
          v-if="!isValid && isValidateClicked"
          :class="$style.buttonGroupSpacing"
          icon="error"
          iconPosition="left"
          status="error"
          :text="invalidJsonMsg"
        />
      </GridItem>
      <GridItem :gridSpan="8">
        <ButtonGroupSave
          :class="$style.buttonGroupSpacing"
          :isFullWidth="false"
          :primaryButtonProps="primaryButtonProps"
          :secondaryButtonProps="secondaryButtonProps"
          @primaryAction="validate"
          @secondaryAction="clear"
        />
      </GridItem>
    </Grid>
  </div>
</template>

<script>
import {
  ButtonGroupSave,
  CopyWell,
  Grid,
  GridItem,
  HeadingExtraSmall,
  StatusBadge,
  Types,
} from '@jumpcloud/ui-components';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';
import IconTooltip from 'components/Tooltip/IconTooltip';

const { PrimaryButtonProps, SecondaryButtonProps } = Types;

export default {
  name: 'DynamicControlsCopyWell',

  components: {
    ButtonGroupSave,
    CopyWell,
    Grid,
    GridItem,
    HeadingExtraSmall,
    IconTooltip,
    StatusBadge,
  },

  mixins: [DynamicControlsMixin],

  props: {
    value: {
      default: '',
      type: String,
    },
  },

  data: () => ({
    primaryButtonProps: PrimaryButtonProps({ text: 'Validate JSON', type: 'primary' }),
    secondaryButtonProps: SecondaryButtonProps({ text: 'Clear', type: 'secondary' }),
    isValidateClicked: false,
    isValid: false,
    validJsonMsg: 'JSON Valid',
    invalidJsonMsg: 'JSON Invalid',
  }),

  methods: {
    clear() {
      this.value = '';
      this.handleChange(this.value);
    },

    validate() {
      try {
        JSON.parse(this.value);
        this.isValid = true;
      } catch (error) {
        this.isValid = false;
      }
      this.isValidateClicked = true;
    },
  },
};
</script>

<style module>
.copyWellFull {
  width: 100%;
}

.buttonGroupSpacing {
  margin-top: var(--jc-spacer-small);
  padding-bottom: var(--jc-spacer);
}

.headerMarginBottom {
  margin-bottom: var(--jc-spacer-x-small);
}

.tooltip {
  margin-left: 0.3rem;
  margin-right: 0.6rem;
  position: relative;
  top: 0;
}

</style>
